import clsx from 'clsx';
import { ComponentLink } from '~components/ComponentLink';

import * as styles from './LinkGroup.module.css';

import type { ContentfulComponentLinkGroup } from '~components/types';

type LinkGroupProps = {
  className?: string;
  linkGroup: ContentfulComponentLinkGroup;
};

export const LinkGroup: React.FC<LinkGroupProps> = ({ className, linkGroup }) => (
  <div className={clsx(styles.linkGroup, className)}>
    <span className={styles.label}>{linkGroup.label}</span>
    {linkGroup.items.map((item) => (
      <ComponentLink key={item.label} link={item} className={styles.link} activeClassName={styles.active}>
        {item.label}
      </ComponentLink>
    ))}
  </div>
);
